import PropTypes from 'prop-types';
import CssClassMixin from '../../mixins/css_class_mixin.jsx';
import TooltipMixin from '../../mixins/tooltip_mixin.jsx';

var createClass = require('create-react-class');

window.Icon = createClass({
  mixins: [CssClassMixin, TooltipMixin],

  propTypes: {
    type: PropTypes.string
  },

  getDefaultProps: function() {
    return {
      type: ''
    };
  },

  getInitialState: function() {
    return {
      themeClassKey: 'icon'
    };
  },

  render: function() {
    return (
      <i className={this.getTooltipClassName()}
        {...this.tooltipAttributes()}
        {...this.propsWithoutCSS()}>
        {this.iconType()}
      </i>
    );
  },

  iconType: function() {
    var iconType = Realize.themes.getProp('icon.' + this.props.type);
    if(!iconType) {
      iconType = this.props.type;
    }

    return iconType;
  }
});
